import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import { user } from "./modules/user_module";
import { viewstate } from "./modules/viewstate_module";
import { config } from "./modules/config_module";
import { topup } from "./modules/topup_module";
import { transactions } from "./modules/transactions_module";
import { wallet } from "./modules/wallet_module";
import { cashout_requests } from "./modules/cashoutrequests_module";
import { product } from "./modules/product_module";
import { webshop } from "./modules/webshop_module";
import { subscription } from "./modules/subscription_module";
import { invoice } from "./modules/invoice_module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user: user,
    viewstate: viewstate,
    topup: topup,
    subscription: subscription,
    invoice: invoice,
    config: config,
    transactions: transactions,
    wallet: wallet,
    cashout_requests: cashout_requests,
    product: product,
    webshop: webshop
  },
  plugins: [createPersistedState()]
});
